import { all } from 'redux-saga/effects';
import * as blogManager from './blogManager';
import * as pointsManager from './pointsManager';
import * as userManager from './userManager';
import * as emailManager from './emailManager'

export default function* saga() {
  yield all([pointsManager.saga(), userManager.saga(), blogManager.saga(), emailManager.saga()]);

}
